import { useTranslation } from "react-i18next";
import Label from "../../../components/Label";
import { useRecordContext } from "react-admin";

// The approval state of a transfer, as a status badge (same style as StatusLabel).
export const ApprovalStatusBadge = () => {
  const { t }: { t: any } = useTranslation();
  const record = useRecordContext();

  if (!record) return null;

  if (record.approvedBy) {
    return <Label color="success">{t("Approved")}</Label>;
  }

  if (record.statusOrder === "FAILED" && record.approvalRequired) {
    return <Label color="error">{t("Rejected or timed out")}</Label>;
  }

  return <Label color="info">{t("Pending approval")}</Label>;
};
